import { store } from '~/plugins/vuex';

export default defineNuxtRouteMiddleware(async () => {
  await store.dispatch('auth/logout');
});
